<ul class="navbar-nav flex-grow">
  @if (showServicesDropdown) {
    <li class="nav-item dropdown">
      <a
        class="nav-link dropdown-toggle"
        [routerLink]="['/cert']"
        [routerLinkActive]="['link-active']"
        role="button"
        data-bs-toggle="dropdown"
        aria-expanded="false"
      >
        Service Items
        @if (leaRushRequestsCount() > 0) {
          <span
            class="badge rounded-pill bg-danger text-white position-relative"
            style="top: -6px; left: 2px; font-size: 0.65rem; min-width: 1.25rem"
          >
            {{ leaRushRequestsCount() }}
          </span>
        }
      </a>
      <ul class="dropdown-menu">
        <li>
          <a
            requiresPolicy="canManageAdminQueue"
            class="dropdown-item"
            [routerLinkActive]="['link-active']"
            [routerLink]="['/cert/services/service-items-admin']"
          >
            Service Items Admin</a
          >
        </li>
        <li>
          <a
            requiresPolicy="canSelfAssignServiceItems"
            class="dropdown-item"
            [routerLinkActive]="['link-active']"
            [routerLink]="['/cert/services']"
          >
            My Service Items
            @if (leaRushRequestsCount() > 0) {
              <span
                class="badge rounded-pill bg-danger text-white position-relative"
                style="top: -6px; left: 2px; font-size: 0.65rem; min-width: 1.25rem"
              >
                {{ leaRushRequestsCount() }}
              </span>
            }
          </a>
        </li>
        <li>
          <a
            requiresPolicy="canSelfAssignServiceItems"
            class="dropdown-item"
            [routerLinkActive]="['link-active']"
            [routerLink]="['/cert/services/unassigned-services']"
            >Unassigned Service Items</a
          >
        </li>
      </ul>
    </li>
  }

  @if (showEducatorsDropdown) {
    <li class="nav-item dropdown">
      <a
        class="nav-link dropdown-toggle"
        [routerLink]="['/cert/educators']"
        [routerLinkActive]="['link-active']"
        role="button"
        data-bs-toggle="dropdown"
        aria-expanded="false"
      >
        Educators
        @if (complexProfessionalDevelopmentEnabled() && professionalDevelopmentVerificationRequestsCount() > 0) {
          <span
            class="badge rounded-pill bg-danger text-white position-relative"
            style="top: -6px; left: 2px; font-size: 0.65rem; min-width: 1.25rem"
          >
            {{ professionalDevelopmentVerificationRequestsCount() }}
          </span>
        }
      </a>
      <ul class="dropdown-menu">
        <li requiresPolicy="canReviewDocuments">
          <a
            class="dropdown-item"
            [routerLinkActive]="['link-active']"
            [routerLink]="['/cert/educators/document-review']"
            >Document Review</a
          >
        </li>
        <li requiresPolicy="canCreatePrintJobs">
          <a class="dropdown-item" [routerLinkActive]="['link-active']" [routerLink]="['/cert/educators/print-queue']"
            >Print Queue</a
          >
        </li>
        <li requiresPolicy="canCreatePrintJobs">
          <a class="dropdown-item" [routerLinkActive]="['link-active']" [routerLink]="['/cert/educators/print-jobs']"
            >Print Jobs</a
          >
        </li>
        @if (mismatchedFingerprintsReportFeatureEnabled$ | async) {
          <li requiresPolicy="canViewDPSFeedFingerprintCards">
            <a
              class="dropdown-item"
              [routerLinkActive]="['link-active']"
              [routerLink]="['/cert/educators/mismatched-fingerprints']"
              >Mismatched Fingerprints Report</a
            >
          </li>
        }
        @if (complexProfessionalDevelopmentEnabled()) {
          <li>
            <a
              class="dropdown-item"
              [routerLinkActive]="['link-active']"
              [routerLink]="['/cert/educators/professional-development']"
            >
              Professional Development
              @if (professionalDevelopmentVerificationRequestsCount() > 0) {
                <span
                  class="badge rounded-pill bg-danger text-white position-relative"
                  style="top: -6px; left: 2px; font-size: 0.65rem; min-width: 1.25rem"
                >
                  {{ professionalDevelopmentVerificationRequestsCount() }}
                </span>
              }
            </a>
          </li>
        }
      </ul>
    </li>
  }

  <li class="nav-item dropdown" requiresPolicy="canViewPayments">
    <a
      class="nav-link dropdown-toggle"
      [routerLink]="['/cert']"
      [routerLinkActive]="['link-active']"
      role="button"
      data-bs-toggle="dropdown"
      aria-expanded="false"
      >Payments</a
    >
    <ul class="dropdown-menu">
      <li requiresPolicy="canEnterPaymentReversal">
        <a
          class="dropdown-item"
          [routerLinkActive]="['link-active']"
          [routerLink]="['/cert/payments/payment-reversals']"
          >Add Payment Reversal</a
        >
      </li>
      <li requiresPolicy="canViewPaymentReversalReport">
        <a class="dropdown-item" [routerLinkActive]="['link-active']" [routerLink]="['/cert/payments/reversal-report']"
          >Payment Reversals Work Queue</a
        >
      </li>
      <li requiresPolicy="canProcessRefunds">
        <a class="dropdown-item" [routerLinkActive]="['link-active']" [routerLink]="['/cert/payments/refunds']"
          >Refunds Work Queue</a
        >
      </li>
      <li requiresPolicy="canViewCollectedPaymentsReport">
        <a class="dropdown-item" [routerLinkActive]="['link-active']" [routerLink]="['/cert/payments/collected-report']"
          >Collected Payments Report</a
        >
      </li>
      <li requiresPolicy="canApprovePendingPayments">
        <a class="dropdown-item" [routerLinkActive]="['link-active']" [routerLink]="['/cert/payments/pending-payments']"
          >Pending Payments</a
        >
      </li>
    </ul>
  </li>

  <li class="nav-item dropdown" requiresPolicy="canViewDiscipline">
    <a
      class="nav-link dropdown-toggle"
      [routerLink]="['/cert']"
      [routerLinkActive]="['link-active']"
      role="button"
      data-bs-toggle="dropdown"
      aria-expanded="false"
      >Discipline</a
    >
    <ul class="dropdown-menu">
      <li requiresPolicy="canViewNasdtecEntries">
        <a
          class="dropdown-item"
          [routerLinkActive]="['link-active']"
          [routerLink]="['/cert/discipline/nasdtec-matches']"
          >NASDTEC Matches</a
        >
      </li>
      <li requiresPolicy="canViewInvestigativeAlerts">
        <a
          class="dropdown-item"
          [routerLinkActive]="['link-active']"
          [routerLink]="['/cert/discipline/iu-fingerprint-cards-report']"
          >IU Fingerprint Cards Report</a
        >
      </li>
      <li requiresPolicy="canManuallyProcessCaseIQCaseClosures">
        <a
          class="dropdown-item"
          [routerLinkActive]="['link-active']"
          [routerLink]="['/cert/discipline/case-iq-automation-report']"
          >Case IQ Automation Report</a
        >
      </li>
    </ul>
  </li>

  @if (showLabDropdown) {
    <li class="nav-item dropdown">
      <a
        class="nav-link dropdown-toggle"
        [routerLink]="['/cert/lab']"
        [routerLinkActive]="['link-active']"
        role="button"
        data-bs-toggle="dropdown"
        aria-expanded="false"
        >Lab</a
      >
      <ul class="dropdown-menu dropdown-menu-left">
        @if (!isProdEnvironment) {
          <li>
            <a class="dropdown-item" [routerLinkActive]="['link-active']" [routerLink]="['/cert//lab']">Style Guide</a>
          </li>
          <li>
            <a class="dropdown-item" [routerLinkActive]="['link-active']" [routerLink]="['/cert/lab/user-list']"
              >User List</a
            >
          </li>
          <li>
            <a class="dropdown-item" [routerLinkActive]="['link-active']" [routerLink]="['/cert/lab/ag-grid']"
              >AG Grid</a
            >
          </li>
          <li>
            <a class="dropdown-item" [routerLinkActive]="['link-active']" [routerLink]="['/cert/lab/data-dictionary']"
              >Data Dictionary</a
            >
          </li>
          <li>
            <a class="dropdown-item" [routerLinkActive]="['link-active']" [routerLink]="['/cert/lab/pdf-test']"
              >Test PDF Generation</a
            >
          </li>
        }
        @if (!isProdEnvironment) {
          <li>
            <a class="dropdown-item" [routerLinkActive]="['link-active']" [routerLink]="['/cert/lab/scanner']"
              >Scanner</a
            >
          </li>
          <li>
            <a class="dropdown-item" [routerLinkActive]="['link-active']" [routerLink]="['/cert/lab/case-iq']"
              >CaseIQ</a
            >
          </li>
          <li>
            <a class="dropdown-item" [routerLinkActive]="['link-active']" [routerLink]="['/cert/lab/nasdtec']"
              >NASDTEC</a
            >
          </li>
          <li>
            <a
              class="dropdown-item"
              [routerLinkActive]="['link-active']"
              [routerLink]="['/cert/lab/document-verification']"
              >Verify Document</a
            >
          </li>
          <li>
            <a
              class="dropdown-item"
              [routerLinkActive]="['link-active']"
              requiresPolicy="canUseLabTestingTools"
              [routerLink]="['/cert/lab/sftp-testing/transcript']"
              >Transcript SFTP Testing</a
            >
          </li>
          <li>
            <a
              class="dropdown-item"
              [routerLinkActive]="['link-active']"
              requiresPolicy="canUseLabTestingTools"
              [routerLink]="['/cert/lab/sftp-testing/fingerprint']"
              >Fingerprint SFTP Testing</a
            >
          </li>
          <li>
            <a
              class="dropdown-item"
              [routerLinkActive]="['link-active']"
              requiresPolicy="canUseLabTestingTools"
              [routerLink]="['/cert/lab/sftp-testing/test']"
              >Test SFTP Testing</a
            >
          </li>
          @if (acEvaluationEnabled$ | async) {
            <li>
              <a
                class="dropdown-item"
                [routerLinkActive]="['link-active']"
                requiresPolicy="canManuallyRecalculateAC"
                [routerLink]="['/cert/lab/appropriately-certified']"
                >Appropriately Certified Testing</a
              >
            </li>
          }
          <li>
            <a
              class="dropdown-item"
              [routerLinkActive]="['link-active']"
              requiresPolicy="canUseLabTestingTools"
              [routerLink]="['/cert/lab/test-emails']"
              >Test Emails</a
            >
          </li>
        }
      </ul>
    </li>
  }

  <li class="nav-item">
    <a
      class="nav-link clickable"
      [routerLink]="['/cert/help']"
      [routerLinkActive]="['link-active']"
      role="button"
      aria-expanded="false"
      >Help</a
    >
  </li>
  <li class="nav-item" requiresPolicy="canViewLeaContactsInCert">
    <a
      class="nav-link clickable"
      [routerLink]="['/cert/contacts']"
      [routerLinkActive]="['link-active']"
      role="button"
      aria-expanded="false"
      >Contacts</a
    >
  </li>
</ul>
